import { Injectable } from '@angular/core';
import { Photo } from './photo';
import { PhotoList } from './photo-list.mock';


@Injectable()
export class PhotoService {

  constructor() { }

  getPhotos() {
    return PhotoList;
  }
}



// WEBPACK FOOTER //
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/app/home/evuslider/photo.service.ts